import { footerLinks } from '@/mocks/home';

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-14 md:px-8 md:py-16">
        <div className="grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-sm font-bold text-background-50">
                44
              </span>
              <span className="font-heading text-lg font-bold text-foreground-950">44黑料区</span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-7 text-foreground-600">
              一个把全网热点收集、梳理并归档的内容站。所有内容以公开信息整理为主，仅作浏览参考，欢迎纠错反馈。
            </p>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-bold text-foreground-950">{group.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-background-200 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-xs text-foreground-500">
            © 2026 44黑料区 · 内容整理与呈现仅为浏览体验服务
          </p>
          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 text-xs text-foreground-500">
            <span className="flex items-center gap-1.5">
              <i className="ri-shield-check-line text-sm" />
              信息仅供参考
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-error-warning-line text-sm" />
              如有侵权请联系删除
            </span>
          </div>
        </div>
      </div>
    </footer>
  );
}